import React, { Fragment, useRef, useState, useEffect, useMemo, createContext, useContext } from 'react'
import useDropDown from './useDropDown'

const context = createContext({})

export default function Menu(props) {
  let {
    as: Element = Fragment,
    children,
    ...rest
  } = props

  const ref = useRef()
  const [open, setOpen] = useState(false)
  const state = useMemo(() => ({ open, setOpen, ref }), [open])

  useEffect(() => {
    const onClick = ({ target, defaultPrevented }) => {
      if (
        ref.current &&
        !ref.current.contains(target) &&
        !defaultPrevented
      ) {
        setOpen(false)
      }
    }

    if (open) {
      document.addEventListener('click', onClick)
    }

    return () => {
      if (open) {
        document.removeEventListener('click', onClick)
      }
    }
  }, [open])

  if (typeof children === 'function') {
    children = children(state)
  }

  return (
    <context.Provider value={state}>
      <Element {...rest} children={children} />
    </context.Provider>
  )
}

Menu.Button = props => {
  let {
    as: Element = 'button',
    children,
    onClick,
    ...rest
  } = props

  const ctx = useContext(context)

  if (typeof children === 'function') {
    children = children(ctx)
  }

  const handleClick = event => {
    if (onClick) {
      onClick(event)
    }
    if (!event.defaultPrevented) {
      ctx.setOpen(open => !open)
    }
  }

  return (
    <Element
      {...rest}
      children={children}
      onClick={handleClick}
    />
  )
}

Menu.Items = props => {
  let {
    as: Element = 'div',
    static: isStatic = false,
    children,
    ...rest
  } = props

  const ctx = useContext(context)

  if (!ctx.open && !isStatic) {
    return null
  }

  if (typeof children === 'function') {
    children = children(ctx)
  }

  return (
    <Element {...rest} children={children} ref={ctx.ref} />
  )
}

Menu.Item = props => {
  let {
    as: Element = Fragment,
    children,
    onClick,
    ...rest
  } = props

  const ctx = useContext(context)

  if (typeof children === 'function') {
    children = children(ctx)
  }

  const handleClick = event => {
    if (onClick) {
      onClick(event, ctx)
    }
  }

  return (
    <Element {...rest} onClick={handleClick} children={children} />
  )
}
